const list = [
  {
    id: 1,
    title: "Kohl Of Honour Intense Kajals",
    price: 249,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/01.jpg?v=1644399711",
    amount: 1,
  },
  {
    id: 2,
    title: "Matte Attack Transferproof Lipstick",
    price: 699,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/1_6f55bcac-3e42-4253-88ee-cec0fa43c62a.jpg?v=1645608270",
    amount: 1,
  },
  {
    id: 3,
    title: "Ace Of Face Foundation Stick",
    price: 999,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/1_529c20ee-c872-4029-9702-8580d7b9a66f.jpg?v=1640178644",
    amount: 1,
  },
  {
    id: 4,
    title: "Matte As Hell Crayon Lipstick",
    price: 799,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/01_d6ffec78-c2b6-4466-8672-233fee0285a8.jpg?v=1644394232",
    amount: 1,
  },
  {
    id: 5,
    title: "Anniversary Kit",
    price: 1999,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/1_0ca61ef7-05ce-49be-9fa1-de7c41b99a1f.jpg?v=1650022932",
    amount: 1,
  },
  {
    id: 6,
    title: "Smudge Me Not Liquid Lipstick",
    price: 499,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/1_ef579f2e-602e-4d2f-bed2-bf0efdf4f184.jpg?v=1644325813",
    amount: 1,
  },
  {
    id: 7,
    title: "Hi-5 Kit ",
    price: 693,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/Hi-5-KIT-WBG-Images1_43e43755-262f-4b35-973a-6e5fad7222a4.jpg?v=1643125074",
    amount: 1,
  },
  {
    id: 8,
    title: "Contour De Force Face Palette",
    price: 799,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/1_51afaa84-af89-42b5-bdb8-a51b01257bc0.jpg?v=1639582607",
    amount: 1,
  },
  {
    id: 9,
    title: "Tipsy Lips Moisturizing Balm",
    author: "by Content Team at Target Publications",
    price: 199,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/sugar-cosmetics-tipsy-lips-moisturizing-balm-01-mojito-15057279877203.jpg?v=1619122412",
    amount: 1,
  },
  {
    id: 10,
    title: "Good Moodies Lip Crayon",
    price: 86,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/01_9e0bf9bb-92a6-45ca-8ce4-ce7d58c617ac.jpg?v=1639496863",
    amount: 1,
  },
  {
    id: 11,
    title: "Dream Cover SPF15 Mattifying Compact",
    author: "by Rebecca Smith  | 14 December 2021",
    price: 499,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/sugar-cosmetics-dream-cover-spf15-mattifying-compact-10-latte-12775602356307.jpg?v=1619106501",
    amount: 1,
  },
  {
    id: 12,
    title: "Base Of Glory Pore Minimizing Primer",
    author: "by Sudha Murty | 1 January 2015",
    price: 799,
    img: "https://cdn.shopify.com/s/files/1/0906/2558/products/1_e9355d54-6ddb-4aa4-bdfc-176a676db886.jpg?v=1639983555",
    amount: 1,
  },
];

export default list;